import repository from '@/utils/repository';

const common_resource = '/move';

export default {
    searchBankInfo: (data) => {
        return repository.post(`${common_resource}/postCommonMst012Info`, {
            ...data
        });
    }
};
